import { dataDictionaryGroupsEntryPoint } from '@jira/assets-app__data-manager-data-dictionary-groups/src/dataDictionaryGroupsEntryPoint.entrypoint.tsx';
import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsDataManagerDataDictionaryGroupRoute } from '@jira/router-routes__assets-app-data-manager-routes/src/assetsDataManagerDataDictionaryGroupRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const assetsDataManagerDataDictionaryGroupPageEntryPoint = createChromelessEntryPoint({
	main: dataDictionaryGroupsEntryPoint,
});

export const assetsDataManagerDataDictionaryGroupRouteEntry: Route = createEntry(
	assetsDataManagerDataDictionaryGroupRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		perfMetricKey: 'assets-data-manager-data-dictionary-group',
		pageId: () => 'spa-apps/assets-data-manager-data-dictionary-group',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],
		entryPoint() {
			return fg('assets_data_manager_jira_spa')
				? assetsDataManagerDataDictionaryGroupPageEntryPoint
				: undefined;
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		meta: {
			reporting: {
				id: APP_NAMES.ASSETS_APP_DATA_MANAGER_DATA_DICTIONARY_GROUP_PAGE,
				packageName: toPackageName(APP_NAMES.ASSETS_APP_DATA_MANAGER_DATA_DICTIONARY_GROUP_PAGE),
				teamName: 'Aurum',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
